<template>
  <div class="add_real_task_wrap">
    <h2 class="add_real_task_wrap_h2">{{drawerTitle}}</h2>
    <el-form :model="realTaskForm" :rules="realTaskFormRules" ref="realTaskForm" :style="'height:'+(windowHeight-80)+'px'">
      <div style="display: flex;justify-content: space-between;">
        <el-form-item style="width: 48%" label="知识点" prop="knowledgePoints">
          <el-select v-model="realTaskForm.knowledgePoints" multiple placeholder="请选择知识点">
            <div v-if="knowledgePointsList.length>0">
              <el-option v-for="item in knowledgePointsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item class="pelabel" style="width: 48%" label="任务类型" prop="taskType">
					<span class="pospan" style="color: firebrick;">（任务推送后，任务类型则不可修改）</span>
          <el-select v-model="realTaskForm.taskType" placeholder="请选择任务类型" :disabled="isDisabled">
            <div v-if="taskTypeList.length>0">
              <el-option v-for="item in taskTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <el-form-item style="width: 48%" label="任务名称" prop="taskTitle">
          <el-input v-model="realTaskForm.taskTitle" placeholder="请输入任务名称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item style="width: 48%" label="所属公司" prop="company">
          <el-select v-model="realTaskForm.company" placeholder="请选择所属公司" filterable clearable>
            <div v-if="companyList.length>0">
              <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="任务内容" prop="taskContent">
        <!-- <p>{{realTaskForm.taskContent}}</p> -->
        <v-editor v-model="realTaskForm.taskContent" class="taskContent" :key="onlyKey"></v-editor>
      </el-form-item>
      <v-addFile :isUploading="isUploading" @changeUploadStatus="changeUploadStatus" v-model="attachmentList"></v-addFile>
      <el-form-item class="btn">
        <el-button @click="submitCancel">取消</el-button>
        <el-button @click="submitForm('realTaskForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import * as api from '../../../../api/courseApi'
import vEditor from "@/components/wjlEditor/index.vue";
import vAddFile from "../../../v_addFile";
export default {
  components:{ vEditor, vAddFile },
  props: ['subjectId','editTask','addrealTaskShow'],
  data() {
    return {
      a:"",
      drawerTitle: '提示',
      windowHeight: window.innerHeight,
      realTaskForm: {
        knowledgePoints: [],
        taskType: '',
        taskTitle: '',
        company: '',
        taskContent: '',
      },
      realTaskFormRules: {
        knowledgePoints: [ { required: true, message: '请选择知识点', trigger: 'change' } ],
        taskType:[ { required: true, message: '请选择任务类型', trigger: 'change' } ],
        taskTitle: [ { required: true, message: '请输入任务名称', trigger: 'blur' } ],
        company:[ { required: true, message: '请选择所属公司', trigger: 'change' } ],
        taskContent: [ { required: true, message: '请输入任务内容', trigger: 'blur' } ],
      },
      kpLevel: 0,
      knowledgePointsList: [],
      taskTypeList: [],
      companyList: [],
      isDisabled: false,
      attachmentList: [],
      isUploading: false,
			loading: false,
			list: [],
onlyKey:0
    }
  },
  mounted(){
    if(this.editTask){
      this.isDisabled = false
      this.drawerTitle = '编辑真实任务'
			console.log(this.isDisabled);
      this.$nextTick(()=>{
        this.getKnowledgePointsArr(this.editTask.resourceId)
      })
    }else{
      this.refresh = !this.refresh;
      this.isDisabled = false
      this.drawerTitle = '新增真实任务'
    }
    this.getKnowledgePoints()
    this.getTaskFlow()
    this.getCompany()
  },
  methods: {

    changeUploadStatus(str) {
      console.log(str)
      console.log(this.attachmentList)
    },
    getKnowledgePoints(){//获取知识点
      let that = this
      api.FindMaterials(this.subjectId).then(rs=>{
        if(rs.code==0){
          that.knowledgePointsList = []
          that.treeData(rs.data.materials)
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    treeData(data){//遍历childre
      let that = this
      let obj = null
      for(let i=0;i<data.length;i++){
        obj = {
          name: data[i].name,
          id: data[i].id,
        }
        this.knowledgePointsList.push(obj)
        if(data[i].children.length==0){
          data[i].children=undefined;
        }else{
          this.treeData(data[i].children)
        }
      }
      return data
    },
    getTaskFlow(){//获取任务流
      api.getTaskFlow(this.subjectId).then(rs=>{
        if(rs.code==0){
          this.taskTypeList = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getCompany(){//获取公司
      let that = this
      let obj = {
        subjectId: this.subjectId,
        lableIds: [4],
				name: ''
      }
      api.queryCompany(obj).then(rs=>{
        if(rs.code==0){
          that.companyList = rs.data;
        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    submitForm(formName){//提交添加任务
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.attachmentList.length>0) {
            this.attachmentList.forEach(attachmentVal=>{
              if (attachmentVal.status == "success") {
                delete attachmentVal.status;
              }
            })
          }
          if(this.drawerTitle=='新增真实任务'){
            let params = {
              subjectId: that.subjectId, // 科目id
              materialIds: that.realTaskForm.knowledgePoints, // 知识点
              taksFlowId: that.realTaskForm.taskType, // 任务类型（任务流）
              taskName:that.realTaskForm.taskTitle, // 任务名称
              companyId:that.realTaskForm.company, // 所属项目（公司）
              questionContent: that.realTaskForm.taskContent, // 任务内容
              internalTypeId: 9, // 内部题型
              labelIds: [4], // 标签
              score: "1", // 分数
              difficulty: "1", // 难度
              attachmentList: that.attachmentList, // 附件
							questionTypeId: 0
            };
						api.createQuestiontData(params).then(rs=>{
						  if(rs.code==0){
						    let obj = {
						      catalogId: 0,
						      courseId: this.$route.query.id,
						      list:[{
						        catalogId: 0,
						        courseId: this.$route.query.id,
						        resourceId: rs.data,
						        type: 3,//实操题
						      }]
						    }
						    this.$emit('addTaskList',obj)
						    this.resetForm('realTaskForm')
						    this.attachmentList = []
								this.realTaskForm.taskContent = ''
						  }else{
						    this.$messageError(rs.msg)
						  }
						})
          }else{
            let params = {
              subjectId: that.subjectId, // 科目id
              materialIds: that.realTaskForm.knowledgePoints, // 知识点
              taksFlowId: that.realTaskForm.taskType, // 任务类型（任务流）
              taskName:that.realTaskForm.taskTitle, // 任务名称
              companyId:that.realTaskForm.company, // 所属项目（公司）
              questionContent: that.realTaskForm.taskContent, // 任务内容
              internalTypeId: 9, // 内部题型
              labelIds: [4], // 标签
              score: "1", // 分数
              difficulty: "1", // 难度
              catalogId: 0,
              id: that.realTaskForm.id,
              questionTypeId: that.realTaskForm.questiontypeId,
              attachmentList: that.attachmentList, // 附件
            }
            api.UpdateTestData(params).then((res)=>{
              if (res.code == 0){
                this.$messageSuccess('修改成功')
                this.$emit('upadtaTaskList')
                this.resetForm('realTaskForm')
                this.attachmentList = []
              }else{
                this.$messageError(rs.msg)
              }
            })
          }
        }
      });
    },
    submitCancel(){
      this.resetForm('realTaskForm')
      this.$emit('submitCancel')
      this.attachmentList = []
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.refresh = !this.refresh;
    },
    getKnowledgePointsArr(id){
      let that = this
      api.getAnswer(id).then(rs=>{
        let arr = []
        if(rs.code==0){
          if(rs.data.materials.length>0){
            rs.data.materials.forEach(v=>{
              arr.push(v.id)
            })
          }else{
            arr = []
          }
          that.realTaskForm = {
            knowledgePoints: arr,
            taskType: that.editTask.taskFlowId,
            taskTitle: that.editTask.taskName,
            company: that.editTask.companyId,
            taskContent: that.editTask.questionContent,
            id: rs.data.questions.id,
            questiontypeId: rs.data.questions.questiontypeId
          }
this.onlyKey++;
          rs.data.materialAttachments.forEach((item,index)=>{
              if ( item == null ) {
                  rs.data.materialAttachments.splice(index, 1)
              }
          })
          that.attachmentList = rs.data.materialAttachments
          this.refresh = !this.refresh;
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
  },
  watch:{
    'addrealTaskShow':function(val){
      let that = this
      if(val){
        if(that.editTask){
          that.drawerTitle = '编辑真实任务'
          that.isDisabled = false
          that.$nextTick(()=>{
            that.getKnowledgePointsArr(that.editTask.resourceId)
          })
        }else{
          that.isDisabled = false
          that.drawerTitle = '新增真实任务'
					this.realTaskForm.taskContent = ''
        }
      }else{
        that.resetForm('realTaskForm')
      }
    }
  }
}
</script>
<style lang="scss">
  .add_real_task_wrap{
    max-height: 100%;
    overflow: hidden;
    .add_real_task_wrap_h2{
      font-size:16px;
      font-weight:bold;
      line-height:60px;
      color:rgba(13,20,30,1);
      letter-spacing:1px;
      padding-left: 23px;
      border-bottom: 1px solid #DDE0E2;
    }
    .el-form{
      padding: 0 23px;
      overflow-y: auto;
      margin-top: 16px;
      .el-form-item__label{
        line-height: 26px;
        float: inherit;

      }
			.pelabel {
				position: relative;
			}
			.pospan {
				position: absolute;
				top: -34px;
				left: 70px;
			}
      .el-select{
        display: block;
        .el-input__prefix, .el-input__suffix{
          height: 40px;
        }
      }
      .taskContent{
        position: relative;
        .editor{
          height: 400px;
          .ql-container{
            height: 360px;
          }
        }
        .ql-snow .ql-editor{
          max-height: inherit;
        }
      }
      .btn{
        text-align: center;
        button{
          width: 80px;
          height: 32px;
          padding: 0;
          &:last-child{
            background: #5397F7;
            color: #fff;
            &:hover{
              opacity: 0.8;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/components/addRealTask.vue